<template>
  <div class="cl-inner">
    <!-- 搜索 -->
    <div class="search-inner">
      <a-form layout="inline">
        <!-- 课程方 -->
        <c-institution-select
          v-show="institutionSelectFlag"
          :institutionCode.sync="queryParam.institutionId"
        ></c-institution-select>

        <!-- 学校 queryParam-->
        <c-school-select
          v-show="schoolSelectFlag"
          :schoolCode.sync="queryParam.schoolId"
        ></c-school-select>

        <a-form-item class="search-oper">
          <a-button type="primary" @click="searchEvaluation()">查询</a-button>
          <a-button type="primary" @click="clearSelect()">重置</a-button>
        </a-form-item>
      </a-form>
    </div>

    <!-- 表格数据 -->
    <a-table
      :columns="columns"
      :dataSource="evaluationList"
      class="c-table"
      :pagination="pagination"
      :loading="loading"
      :rowKey="getRowKey"
      @change="tableChange"
    >
      <span slot="mobile" slot-scope="text, record">
        <template>
          <a class="hover-font-active" @click="toStudentList(text)">{{
            record.mobile
          }}</a>
        </template>
      </span>
      <span slot="content" slot-scope="text, record">
        <a-popover>
            <template slot="content">
                <p>{{ record.content }}</p>
            </template>
            <div class="ellipsis">{{ record.content }}</div>
        </a-popover>
      </span>
      <span slot="score" slot-scope="text, record">
        <template>
          <span>{{ record.score }}分</span>
        </template>
      </span>
      <span slot="courseName" slot-scope="text, record">
        <a-popover>
            <template slot="content">
                <p>{{ record.courseName }}</p>
            </template>
            <div class="ellipsis">{{ record.courseName }}</div>
        </a-popover>
      </span>
      <span slot="action" slot-scope="text, record">
        <template>
          <a @click="deleteEvaluation(record)">删除</a>
        </template>
      </span>
      <span slot="institutionName" slot-scope="text, record">
        <template>
          <span
            >{{ record.institutionName }}
            <a-tag v-if="record.institutionType == 3" color="blue">
              高协
            </a-tag>
          </span>
        </template>
      </span>
    </a-table>
  </div>
</template>
<script>
import person from '../../api/person'

import evaluation from '../../api/evaluation'

import institution from '../../api/institution'

import CSchoolSelect from '../../components/CSchoolSelect'

import CInstitutionSelect from '../../components/CInstitutionSelect'

import school from '../../api/school'

import { analysisAddress } from '../../utils/address'
import menuTreeData from '../../utils/menuTreeData'
const columns = [
  {
    title: '评论者',
    dataIndex: 'nickname',
    width: 150,
  },
  {
    title: '手机号',
    dataIndex: 'mobile',
    scopedSlots: { customRender: 'mobile' },
  },
  {
    title: '内容',
    dataIndex: 'content',
    scopedSlots: { customRender: 'content' },
  },
  {
    title: '评价分数',
    dataIndex: 'score',
    scopedSlots: { customRender: 'score' },
    sorter: true,
  },
  {
    title: '老师名称',
    dataIndex: 'teacherName',
  },
  {
    title: '班级名称',
    dataIndex: 'className',
  },
  {
    title: '课程名称',
    dataIndex: 'courseName',
    scopedSlots: { customRender: 'courseName' },
  },
  {
    title: '学校名称',
    dataIndex: 'schoolName',
  },
  {
    title: '课程方名称',
    dataIndex: 'institutionName',
    scopedSlots: { customRender: 'institutionName' },
  },
  {
    title: '创建时间',
    dataIndex: 'gmtCreate',
    sorter: true,
  },
  {
    title: '操作',
    dataIndex: 'action',
    scopedSlots: { customRender: 'action' },
    width: 60,
  },
]

export default {
  name: 'evaluationList',
  data() {
    return {
      evaluationList: [], //评价数据
      columns: menuTreeData.deepClone(columns), //列标识数据
      queryParam: {}, //查询参数
      pagination: {
        showTotal: (total) => `总共 ${total} 条`, // 显示总数
        current: 1,
        pageSize: 10,
        total: 0,
        pageSizeOptions: ['10', '20', '30', '50', '70', '100'],
        showLessItems: true,
        showSizeChanger: true,
      }, //分页数据对象
      loading: true,
      schoolSelectFlag: true, //是否显示学校的筛选项
      institutionSelectFlag: true, //是否显示课程方的筛选项
    }
  },
  components: {
    CSchoolSelect,
    CInstitutionSelect,
  },
  methods: {
    getRowKey(record, index) {
      return index;
    },
    //去学生列表
    toStudentList(val) {
      this.$router.push({ name: 'studentList', params: { mobile: val } })
    },
    //table发生该表，分页，排序
    tableChange(pagination, filters, sorter) {
      //如果查询有地址的话，把地址解析之后带入
      let obj = analysisAddress(this.queryParam)
      obj.currentPage = pagination.current
      obj.pageSize = pagination.pageSize
      window.location.hash = `#${this.$route.path}?params=${JSON.stringify(
        obj
      )}`
      //存在排序的时候
      if (sorter && sorter.columnKey) {
        obj.sorter = `${sorter.columnKey}-${
          sorter.order == 'ascend' ? 'asc' : 'desc'
        }`
      }
      this.getEvaluationList(obj)
    },

    //删除评论
    deleteEvaluation(value) {
      let self = this
      this.$confirm({
        title: '确定要删除吗?',
        okText: '确定',
        cancelText: '取消',
        content: '删除后，无法撤销',
        onOk() {
          evaluation.deleteEvaluation(value.id).then((res) => {
            self.$message.success('删除成功')
            //前端模拟删除
            self.deleteEvaluationData(self.evaluationList, value.id)
            self.searchEvaluation()
          })
        },
      })
    },

    //删除数据
    deleteEvaluationData(data, id) {
      for (let i in data) {
        if (data[i].id == id) {
          data.splice(i, 1)
          break
        }
      }
    },

    //查询评价
    searchEvaluation() {
      this.queryParam.currentPage = 1
      this.queryParam.pageSize = 10
      window.location.hash = `#${this.$route.path}?params=${JSON.stringify(
        this.queryParam
      )}`
      this.getEvaluationList(this.queryParam)
    },
    //是否有操作权限
    judgeIsOper() {
      this.$store.dispatch('getUserInfo').then(async (res) => {
        //只有课程方，学校、平台才有权限
        let roleId = res.accRole.id.toString()
        //如果是课程方不显示筛选项和列表中不显示学校列
        if (['4'].indexOf(roleId) != -1) {
          this.institutionSelectFlag = false
          this.columns = menuTreeData.deepClone(columns)
          this.columns.map((item, index) => {
            if (item.dataIndex == 'institutionName') {
              this.columns.splice(index, 1)
              return
            }
          })
        } else {
          //如果是学校角色不显示学校筛选项
          if (['3'].indexOf(roleId) != -1) {
            this.schoolSelectFlag = false
            this.columns = menuTreeData.deepClone(columns)
            this.columns.map((item,index)=>{
              if(item.dataIndex == "schoolName"){
                this.columns.splice(index,1);
                return
              }
            })
          } else if (['6'].indexOf(roleId) != -1 && !this.$route.query.params) {
            await school.searchSchool({ schoolName: '' }).then((res) => {
              this.queryParam.schoolId = res.data[0].id
            })
          } else {
            this.columns = menuTreeData.deepClone(columns)
            this.schoolSelectFlag = true
          }
        }
        this.getEvaluationList(this.queryParam)
      })
    },
    //重置
    clearSelect() {
      this.queryParam = {}
      this.getEvaluationList()
    },
    //评价列表
    getEvaluationList(params) {
      this.loading = true
      evaluation.getEvaluationList(params).then((res) => {
        console.log('当前的评价列表是', res.data.list)

        this.evaluationList = res.data.list || []
        this.loading = false
        //分页信息
        this.pagination = res.data.pagination
      })
    },
  },
  created() {
    if (this.$route.query.params) {
      this.queryParam = JSON.parse(this.$route.query.params)
    } else {
      this.queryParam = {}
    }

    this.judgeIsOper()
  },
}
</script>
<style lang="scss" scoped>
@import 'src/config/var';
.cl-inner {
  width: calc(100% - 40px);
  padding: 20px;
  background: white;
  margin: 20px auto;
}
.search-inner {
  margin-bottom: 20px;
}
.search-oper {
  button {
    margin: 0px 5px;
  }
}
.list-oper {
  margin: 20px 0px 30px;
}
.price-scope {
  width: 100px;
  text-align: center;
}
.max-price {
  border-left: none;
}
.price-gap {
  width: 30px;
  border-left: 0;
  pointer-events: none;
  background: #fff;
}
.ellipsis {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 200px;
}
</style>